import { useState, useEffect } from "react";

export function useMediaQuery(query) {
  const [match, setMatch] = useState(false);

  useEffect(() => {

    let media = window.matchMedia(query);

    if(media.matches !== match){
      setMatch(media.matches);
    }

    const listener = () => {
      setMatch(media.matches);
    }

    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);

  }, [match, query]);

  return match;
}